import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Registration } from '../models/registration.model';
import { ApiResponse, ResponseStatus, PayloadResponse } from '../models/response.model';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class LoggerService {

    private lineServiceUrl: string = environment.endpointBackend + '/api';
    constructor(private http: HttpClient) { }

    loggerInfo(payload: any): Observable<any> {
        let body = {};
        if (typeof payload == "object") {
            body = {
                payload: JSON.stringify(payload),
                type: "info"
            };
        } else {
            body = {
                payload: payload,
                type: "info"
            };
        }

        return this.http.post<any>(this.lineServiceUrl + '/log_process', body)
    }
    logger(payload: string): Observable<any> {
        return this.http.post<any>(this.lineServiceUrl + '/log_process', payload)
    }
}
